<template>
  <div class="gj-area-title" :style="{fontSize}">
    <div class="gj-area_chunk" v-if="isChunk"></div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "gj-area-title",
    props: {
      fontSize: {
        type: String,
        default: '14px'
      },
      isChunk: {
        type: Boolean,
        default: true
      }
    },
    
  }
</script>

<style lang="scss" scoped>
  .gj-area-title {
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    .gj-area_chunk{
      height: 14px;
      width: 4px;
      background: #1F6EEF;
      margin-right: 8px;
    }
  }
</style>
